import Button from "components/button/button.component";

function NewsLetterSub() {
  return (
    <div className="flex items-center gap-3">
      <input
        type="text"
        placeholder="Email Address*"
        className="input input-bordered border-[#CECEDE] w-full lg:w-[381px] max-w-sm bg-transparent placeholder:text-[#F7F8FA]"
      />
      <Button
        className="h-[47px] bg-orange-600 dark:bg-[#5A5A5A] text-white"
        isDefault={false}>
        Subscribe
      </Button>
    </div>
  );
}

export default NewsLetterSub;
